import styled from 'styled-components';

export const Wrapper = styled.div`
  margin-top: ${({ theme }): string => theme.spacers!.spacer04};
  display: flex;

  > div {
    width: 250px;
  }
`;
